/**
 * Sport Links Configuration
 * Shared configuration for sport navigation across desktop and mobile
 *
 * This centralizes sport navigation data to follow DRY principles
 * and ensure consistency across the application.
 */

/**
 * Get the list of available sport links
 * @returns {Array<{id: string, label: string, path: string, status: string}>}
 */
export const getSportLinks = () => [
  { id: 'football', label: '100+ Futebol Leagues', path: '/football', status: 'active' },
  { id: 'f1', label: 'F1', path: '/f1', status: 'active' },
  { id: 'nfl', label: 'NFL', path: '/nfl', status: 'active' },
  { id: 'nba', label: 'NBA', path: '/nba', status: 'active' },
  { id: 'ncaaf', label: 'NCAA Football', path: '/ncaaf', status: 'active' },
  { id: 'nhl', label: 'NHL', path: '/nhl', status: 'active' },
  { id: 'mma', label: 'MMA', path: '/mma-fights', status: 'active' },
  { id: 'volleyball', label: 'Volleyball', path: '/volleyball', status: 'active' },
  { id: 'wnba', label: 'WNBA', path: '/wnba', status: 'coming-soon' },
  { id: 'mlb', label: 'Baseball', path: '/mlb', status: 'active' },
];
